import { createStore } from "vuex";
import loading from "./modules/loading";
export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        loading,
    },
});
